/**
 * Loading state while room data loads.
 */
export function RoomLoadingState() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-primary">
      <div className="text-center">
        <div className="animate-spin w-10 h-10 border-3 border-accent border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-gray-400">Loading room...</p>
      </div>
    </div>
  );
}
